module.exports = __webpack_public_path__ + "static/media/davos_slider_1.e5c05f30.jpg";